<div [formGroup]="form">
  <!-- <header class="oswald primary text-center interview-request-title">
    My Details
  </header> -->
  <div class="interview-request-content">
    All new Campers must pass a FREE interview and trial day before
    participating in day care or boarding.
  </div>
  <br />
  <div class="interview-request-content mb-3">
    Select an existing dog or add dog to begin.
  </div>
  <hr style="margin: 1.25rem 0" />
  <div class="interview-request-note-box">
    <div class="interview-request-note-title">Please note:</div>
    <div class="col interview-request-note-text">
      Interviews are typically scheduled for 30-45 minutes per dog. If you have multiple dogs
      , they can be scheduled back-to-back if time slots are available. We require all Campers
      to stay a minimum of 3 hours as part of the interview, but they are welcome to stay to play
      all day (must pick up before we close!). Pet Parents only need to stay for the initial 30-45 minute interview per dog.
    </div>
  </div>
  <br />
  <div
    *ngIf="isErrorOnSave"
    class="error-box alt"
  >
    <img
      src="assets/svg/ico_error_circle.svg"
      alt="Error icon"
      width="24"
      class="mb-1"
    />
    <div class="error-box-text">
      There is a problem with your request. Please review below.
    </div>
  </div>
  <div
    *ngFor="
      let pet of petTileList$ | async | slice: 0:petList.length;
      let i = index;
      let isLastChild = last
    "
    [style.marginBottom]="isLastChild ? '0' : '0.5rem'"
  >
    <app-pet-tile-form
      *ngIf="pet.weight && pet.breeds && pet.breeds.length != 0"
      #ptForm
      [form]="petFormArray.controls[i]"
      [petInfo]="petList[i]"
      [isErrorOnSave]="isErrorOnSave"
      [breedList]="[]"
    ></app-pet-tile-form>
  </div>
  <hr style="margin: 1.25rem 0" />
  <div
    *ngFor="
      let pet of petFormArray.controls | slice: petList.length;
      let isLastChild = last
    "
    [style.marginBottom]="isLastChild ? '1rem' : '0.5rem'"
  >
    <app-pet-tile-form
      [form]="pet"
      [isErrorOnSave]="isErrorOnSave"
      [breedList]="breedList"
    ></app-pet-tile-form>
  </div>
  <app-arrow-link
    text="+ Add a Dog"
    (handleClick)="addPet(-1, '', true)"
  ></app-arrow-link>
  <!-- <hr style="margin: 1.25rem 0" />
  <div class="pet-info-label">Please note:</div>
  <div class="interview-request-content">
    Interviews are typically scheduled for 45-60 minutes per dog. If you have
    multiple dogs, they can be scheduled back-to-back if time slots are
    available.
  </div> -->
  <div style="margin-top: 2.5rem">
    <hr />
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onSave()"
        [disabled]="!isSaveEnabled"
      >
        Save + Continue
      </button>
    </footer>
  </div>
</div>
